import * as React from 'react';

import IconStep1 from '@/assets/icons/icon_step_1.svg';
import IconStep2 from '@/assets/icons/icon_step_2.svg';
import IconStep3 from '@/assets/icons/icon_step_3.svg';
import Image from '@/components/elements/Image';

import { Flow, FlowStepIcon, Text, TitleSmall } from '../../style';
import { FlowImage, FlowWrapper } from './style';

export type StepDataType = {
  image: JSX.IntrinsicElements['img'];
  title: string;
  text: string | JSX.Element;
};

interface VotingSingleStepProps {
  data: StepDataType[];
}

const VotingSingleStep: React.FC<VotingSingleStepProps> = ({ data }) => {
  const iconData = [IconStep1, IconStep2, IconStep3];
  return (
    <Flow>
      {data.map((item, i) => (
        <li key={i}>
          <FlowStepIcon>
            <Image
              srcSet={iconData[i]}
              alt={`step${i}`}
              width="48px"
              height="54px"
            />
          </FlowStepIcon>
          <FlowWrapper>
            <FlowImage>{item.image}</FlowImage>
            <div>
              <TitleSmall textAlign="left">{item.title}</TitleSmall>
              <Text>{item.text}</Text>
            </div>
          </FlowWrapper>
        </li>
      ))}
    </Flow>
  );
};

export default VotingSingleStep;
